export default {
  path: 'prov-remedy-req-management',
  component: () =>
    import('@/views/uspqrp/prov-remedy-req-management/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'prov-remedy-req-management',
      component: () =>
        import('@/views/uspqrp/prov-remedy-req-management/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.provremedyreqmanagement'],
        },
      },
    },
    {
      path: 'add/:studentSieId/:requestId?',
      name: 'prov-remedy-req-management-add',
      component: () =>
        import(
          '@/views/uspqrp/prov-remedy-req-management/ProvRemRequestManagement.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.uspqrp.provremedyreqmanagement'],
        },
      },
    },
  ],
};
